import { ModalPlateBirth } from "src/ui/widgets";
import { useManagerRoot } from "./manager-root.hook";

export const ManagerRoute = () => {
  const { modalPlateVisibility, onConfirmPlateModel } =
    useManagerRoot();

  if (modalPlateVisibility)
    return <ModalPlateBirth onConfirm={onConfirmPlateModel} />;

  return <></>;
};
